import moment from 'moment'
import i18n from '@/i18n'

export const getPeriodStartDate = (periodStartDateStr, startDateStr) => {
  const periodStartDate = new Date(periodStartDateStr)
  const startDate = new Date(startDateStr)
  const newPeriodStartDate = (periodStartDate.getTime() > startDate.getTime()) ? periodStartDateStr : startDateStr

  return newPeriodStartDate
}

export const getPeriodEndDate = (periodEndDateStr, endDateStr) => {
  const periodEndDate = new Date(periodEndDateStr)
  const endDate = new Date(endDateStr)
  const newPeriodEndDate = (periodEndDate.getTime() < endDate.getTime()) ? periodEndDateStr : endDateStr

  return newPeriodEndDate
}

export const isValidStartEndInPeriod = (periodStart, periodEnd, startDateStr, endDateStr) => {
  const periodStartDateStr = (periodStart === undefined) ? '' : periodStart
  const periodEndDateStr = (periodEnd === undefined) ? '' : periodEnd

  if (periodStartDateStr !== '' && periodEndDateStr !== '') {
    const periodStartDate = new Date(periodStartDateStr)
    const periodEndDate = new Date(periodEndDateStr)
    const startDate = new Date(startDateStr)
    const endDate = new Date(endDateStr)
    const isStartDateInPeriod = ((periodStartDate.getTime() <= startDate.getTime()) && (startDate.getTime() <= periodEndDate.getTime()))
    const isEndDateInPeriod = ((periodStartDate.getTime() <= endDate.getTime()) && (endDate.getTime() <= periodEndDate.getTime()))
    const isInPeriod = ((startDate.getTime() <= periodStartDate.getTime()) && (periodEndDate.getTime() <= endDate.getTime()))

    if (isStartDateInPeriod || isEndDateInPeriod || isInPeriod) {
      return true
    }
  }

  return false
}

export const sortPeriodList = (prev, next) => {
  const prevStartDate = new Date(prev.startDate)
  const nextStartDate = new Date(next.startDate)

  return (prevStartDate.getTime() < nextStartDate.getTime()) ? -1 : 1
}

const short = (dateString, lang = '') => {
  const locale = (lang === '') ? i18n.locale : lang
  moment.locale(locale)
  return moment(dateString).format('DD MMM YY')
}

const long = (dateString, lang = '') => {
  const locale = (lang === '') ? i18n.locale : lang
  moment.locale(locale)
  const format = (locale === 'th') ? 'dd DD MMM YYYY HH:mm' : 'ddd. DD MMM YYYY HH:mm'
  return moment(dateString).format(format)
}

export const dateFormat = {
  short: short,
  long: long
}
